import { createFeature, createReducer, on } from '@ngrx/store';
import { AsistenciaActions } from './asistencia.actions';
import { AsistenciaState, initialAsistenciaState } from './asistencia.state';

const reducer = createReducer(
  initialAsistenciaState,
  on(AsistenciaActions.loadAsistencia, (state, { studentId }) => ({
    ...state, studentId, loading: true, error: null,
  })),
  on(AsistenciaActions.loadAsistenciaSuccess, (state, { registros }) => ({
    ...state, registros, loading: false,
  })),
  on(AsistenciaActions.loadAsistenciaFailure, (state, { error }) => ({
    ...state, loading: false, error,
  })),
);

export const asistenciaFeature = createFeature<'asistencia', AsistenciaState>({
  name: 'asistencia',
  reducer,
});
